import { render, staticRenderFns } from "./DoubleDatePicker.vue?vue&type=template&id=8bba3fa2"
import script from "./DoubleDatePicker.vue?vue&type=script&lang=ts"
export * from "./DoubleDatePicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports